export interface ExchangeOption {
  value: string;
  label: string;
}

export interface SymbolOption {
  value: string;
  label: string;
}

export const EXCHANGE_LIST: ExchangeOption[] = [
  { value: 'binance', label: 'Binance Futures' },
  { value: 'okx', label: 'OKX SWAP' },
  { value: 'bybit', label: 'Bybit Linear' },
  { value: 'bitget', label: 'Bitget Futures' },
];

export const getEnabledExchanges = (enabledFlags?: Record<string, boolean>): ExchangeOption[] => {
  if (!enabledFlags) return EXCHANGE_LIST;
  return EXCHANGE_LIST.filter(opt => enabledFlags[opt.value] !== false);
};

export const getSymbols = (exchange?: string, isTestnet?: boolean): SymbolOption[] => {
  const ex = exchange?.toLowerCase();
  
  if (ex === 'okx') {
    return [
      { value: 'BTC-USDT-SWAP', label: 'BTC-USDT-SWAP' },
      { value: 'ETH-USDT-SWAP', label: 'ETH-USDT-SWAP' },
      { value: 'BNB-USDT-SWAP', label: 'BNB-USDT-SWAP' },
      { value: 'SOL-USDT-SWAP', label: 'SOL-USDT-SWAP' },
      { value: 'XRP-USDT-SWAP', label: 'XRP-USDT-SWAP' },
      { value: 'DOGE-USDT-SWAP', label: 'DOGE-USDT-SWAP' },
      { value: 'TRX-USDT-SWAP', label: 'TRX-USDT-SWAP' },
      { value: 'LTC-USDT-SWAP', label: 'LTC-USDT-SWAP' },
      { value: 'LINK-USDT-SWAP', label: 'LINK-USDT-SWAP' },
      { value: 'NEAR-USDT-SWAP', label: 'NEAR-USDT-SWAP' },
      { value: 'ENA-USDT-SWAP', label: 'ENA-USDT-SWAP' },
      { value: 'TAO-USDT-SWAP', label: 'TAO-USDT-SWAP' },
      { value: 'TURBO-USDT-SWAP', label: 'TURBO-USDT-SWAP' },
      { value: 'WLD-USDT-SWAP', label: 'WLD-USDT-SWAP' },
      { value: 'AAVE-USDT-SWAP', label: 'AAVE-USDT-SWAP' },
      { value: 'SUI-USDT-SWAP', label: 'SUI-USDT-SWAP' },
      { value: 'ONDO-USDT-SWAP', label: 'ONDO-USDT-SWAP' },
    ];
  }

  if (ex === 'bybit') {
    return [
      { value: 'BTCUSDT', label: 'BTCUSDT' },
      { value: 'ETHUSDT', label: 'ETHUSDT' },
      { value: 'BNBUSDT', label: 'BNBUSDT' },
      { value: 'SOLUSDT', label: 'SOLUSDT' },
      { value: 'XRPUSDT', label: 'XRPUSDT' },
      { value: 'DOGEUSDT', label: 'DOGEUSDT' },
      { value: 'TRXUSDT', label: 'TRXUSDT' },
      { value: 'LTCUSDT', label: 'LTCUSDT' },
      { value: 'LINKUSDT', label: 'LINKUSDT' },
      { value: 'NEARUSDT', label: 'NEARUSDT' },
      { value: 'ENAUSDT', label: 'ENAUSDT' },
      { value: 'TAOUSDT', label: 'TAOUSDT' },
      { value: 'TURBOUSDT', label: 'TURBOUSDT' },
      { value: 'WLDUSDT', label: 'WLDUSDT' },
      { value: 'AAVEUSDT', label: 'AAVEUSDT' },
      { value: 'SUIUSDT', label: 'SUIUSDT' },
      { value: 'ONDOUSDT', label: 'ONDOUSDT' },
    ];
  }

  if (ex === 'bitget') {
    return [
      { value: 'BTCUSDT', label: 'BTCUSDT' },
      { value: 'ETHUSDT', label: 'ETHUSDT' },
      { value: 'BNBUSDT', label: 'BNBUSDT' },
      { value: 'SOLUSDT', label: 'SOLUSDT' },
      { value: 'XRPUSDT', label: 'XRPUSDT' },
      { value: 'DOGEUSDT', label: 'DOGEUSDT' },
      { value: 'TRXUSDT', label: 'TRXUSDT' },
      { value: 'LTCUSDT', label: 'LTCUSDT' },
      { value: 'LINKUSDT', label: 'LINKUSDT' },
      { value: 'NEARUSDT', label: 'NEARUSDT' },
      { value: 'ENAUSDT', label: 'ENAUSDT' },
      { value: 'TAOUSDT', label: 'TAOUSDT' },
      { value: 'TURBOUSDT', label: 'TURBOUSDT' },
      { value: 'WLDUSDT', label: 'WLDUSDT' },
      { value: 'AAVEUSDT', label: 'AAVEUSDT' },
      { value: 'SUIUSDT', label: 'SUIUSDT' },
      { value: 'ONDOUSDT', label: 'ONDOUSDT' },
    ];
  }
  
  return [
    { value: 'BTCUSDT', label: 'BTCUSDT Perpetual' },
    { value: 'ETHUSDT', label: 'ETHUSDT Perpetual' },
    { value: 'BNBUSDT', label: 'BNBUSDT Perpetual' },
    { value: 'SOLUSDT', label: 'SOLUSDT Perpetual' },
    { value: 'XRPUSDT', label: 'XRPUSDT Perpetual' },
    { value: 'DOGEUSDT', label: 'DOGEUSDT Perpetual' },
    { value: 'ADAUSDT', label: 'ADAUSDT Perpetual' },
    { value: 'TRXUSDT', label: 'TRXUSDT Perpetual' },
    { value: 'LTCUSDT', label: 'LTCUSDT Perpetual' },
    { value: 'LINKUSDT', label: 'LINKUSDT Perpetual' },
    { value: 'NEARUSDT', label: 'NEARUSDT Perpetual' },
    { value: 'ENAUSDT', label: 'ENAUSDT Perpetual' },
    { value: 'TAOUSDT', label: 'TAOUSDT Perpetual' },
    { value: 'TURBOUSDT', label: 'TURBOUSDT Perpetual' },
    { value: 'WLDUSDT', label: 'WLDUSDT Perpetual' },
    { value: 'AAVEUSDT', label: 'AAVEUSDT Perpetual' },
    { value: 'SUIUSDT', label: 'SUIUSDT Perpetual' },
    { value: 'ONDOUSDT', label: 'ONDOUSDT Perpetual' },
  ];
};

export const getCurrency = (symbol?: string): string => {
  const s = symbol || '';
  return (s.includes('USDT') || s.includes('USD')) ? 'USDT' : 'KRW';
};

export const getSymbolHint = (exchange?: string): string => {
  const ex = exchange?.toLowerCase();
  if (ex === 'okx') return '* OKX 형식: BTC-USDT-SWAP';
  if (ex === 'bybit') return '* 바이비트 형식: BTCUSDT';
  if (ex === 'bitget') return '* 비트겟 형식: BTCUSDT';
  return '* 바이낸스 형식: BTCUSDT';
};

export const getMinNotionalWarning = (
  exchange: string | undefined,
  isLive: boolean,
  isTestnet: boolean | undefined,
  notional: number,
  minNotional: number | undefined
): string | null => {
  if (exchange === 'binance' && isLive && isTestnet && notional < (minNotional || 100)) {
    return `바이낸스 테스트넷 최소 주문 제한: ${minNotional || 100} USDT (현재 규모: ${notional.toFixed(2)} USDT)`;
  }
  return null;
};

export const getDefaultSymbol = (exchange?: string): string => {
  const ex = exchange?.toLowerCase();
  if (ex === 'okx') return 'BTC-USDT-SWAP';
  return 'BTCUSDT';
};
